import clientService from '@/services/tmed-plans/client.service';

const state = {
  client: null,
  clientData: null,
  registerStatus: 'init',
  getClientStatus: 'init',
  updateStatus: 'init',
  error: null,
};

const getters = {
  getClient: (state) => state.client,
  getClientData: (state) => state.clientData,
  getRegisterStatus: (state) => state.registerStatus,
  getClientStatus: (state) => state.getClientStatus,
  getUpdateStatus: (state) => state.updateStatus,
  getError: (state) => state.error,
};

const actions = {
  async registerClient({ commit }, clientData) {
    try {
      commit('SET_REGISTER_STATUS', 'loading');
      const response = await clientService.registerClient(clientData);
      commit('SET_CLIENT', response);
      commit('SET_REGISTER_STATUS', 'init');
      return response;
    } catch (error) {
      commit('SET_ERROR', error?.response?.data?.message || 'Erro ao registrar cliente');
      commit('SET_REGISTER_STATUS', 'init');
      throw error;
    }
  },

  async getClient({ commit }) {
    try {
      commit('SET_GET_CLIENT_STATUS', 'loading');
      const response = await clientService.getClient();
      commit('SET_CLIENT_DATA', response);
      commit('SET_GET_CLIENT_STATUS', 'init');

      const user = response?.items?.[0] ?? response;
      if (user && typeof localStorage !== 'undefined') {
        localStorage.setItem('user', JSON.stringify(user));
        commit('plans-auth/SET_USER', user, { root: true });
      }

      return response;
    } catch (error) {
      commit('SET_ERROR', error?.response?.data?.message || 'Erro ao buscar cliente');
      commit('SET_GET_CLIENT_STATUS', 'init');
      throw error;
    }
  },

  async updateClient({ commit }, { cpf, clientData }) {
    try {
      commit('SET_UPDATE_STATUS', 'loading');
      const response = await clientService.updateClient(cpf, clientData);
      commit('SET_UPDATE_STATUS', 'init');
      return response;
    } catch (error) {
      commit('SET_ERROR', error?.response?.data?.message || 'Erro ao atualizar cliente');
      commit('SET_UPDATE_STATUS', 'init');
      throw error;
    }
  },

  clearClient({ commit }) {
    commit('CLEAR_CLIENT');
  },
};

const mutations = {
  SET_CLIENT(state, client) {
    state.client = client;
  },

  SET_CLIENT_DATA(state, clientData) {
    state.clientData = clientData;
  },

  SET_REGISTER_STATUS(state, status) {
    state.registerStatus = status;
  },

  SET_GET_CLIENT_STATUS(state, status) {
    state.getClientStatus = status;
  },

  SET_UPDATE_STATUS(state, status) {
    state.updateStatus = status;
  },

  SET_ERROR(state, error) {
    state.error = error;
  },

  CLEAR_CLIENT(state) {
    state.client = null;
    state.clientData = null;
    state.error = null;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
